import React from 'react';
import FundinnoImg01 from '../../../../../assets/images/views/lps/fundraising_sim/fun_img01.png';
import FundinnoImgSp01 from '../../../../../assets/images/views/lps/fundraising_sim/fun_img-sp01.png';
import FundinnoImg02 from '../../../../../assets/images/views/lps/fundraising_sim/fun_img02.png';
import FundinnoImgSP02 from '../../../../../assets/images/views/lps/fundraising_sim/fun_img-sp02.png';
import PlusImg01 from '../../../../../assets/images/views/lps/fundraising_sim/plus_img01.png';
import PlusImgSp01 from '../../../../../assets/images/views/lps/fundraising_sim/plus_img-sp01.png';
import PlusImg02 from '../../../../../assets/images/views/lps/fundraising_sim/plus_img02.png';
import PlusImgSP02 from '../../../../../assets/images/views/lps/fundraising_sim/plus_img-sp02.png';

type Props = {
  variant: 'ecf' | 'plus' | 'about_company' | 'none';
};

const SimulatorHeader = ({ variant }: Props) => {
  if (variant === 'none') {
    return null;
  }

  // ECFヘッダー描画
  const renderEcfHeader = () => (
    <h3 className="simulator__header--ecf">
      <span className="consider-text">
        <img
          className="sp-none"
          src={FundinnoImg01}
          width="351"
          height="30"
          alt="クラウドファンディング"
        />
        <img
          className="pc-none"
          src={FundinnoImgSp01}
          width="224"
          height="22"
          alt="クラウドファンディング"
        />
      </span>
      <span className="consider-text">
        <img
          className="sp-none"
          src={FundinnoImg02}
          width="535"
          height="48"
          alt="1億円以上の資金調達をご検討の企業様"
        />
        <img
          className="pc-none"
          src={FundinnoImgSP02}
          width="287"
          height="28"
          alt="1億円以上の資金調達をご検討の企業様"
        />
      </span>
    </h3>
  );

  // Plusヘッダー描画
  const renderPlusHeader = () => (
    <h3 className="simulator__header--plus">
      <span className="consider-text">
        <img
          className="sp-none"
          src={PlusImg01}
          width="220"
          height="30"
          alt="大型資金調達"
        />
        <img
          className="pc-none"
          src={PlusImgSp01}
          width="140"
          height="22"
          alt="大型資金調達"
        />
      </span>
      <span className="consider-text">
        <img
          className="sp-none"
          src={PlusImg02}
          width="535"
          height="48"
          alt="1億円以上の資金調達をご検討の企業様"
        />
        <img
          className="pc-none"
          src={PlusImgSP02}
          width="287"
          height="28"
          alt="1億円以上の資金調達をご検討の企業様"
        />
      </span>
    </h3>
  );

  const renderAboutCompanyHeader = () => (
    <h3 className="simulator__header--about_company">
      全13問の質問に答えるだけで
      <br />
      ファンディーノを活用した
      <br className="pc-none tab-none" />
      資金調達額を診断します
    </h3>
  );

  // variant別の描画
  switch (variant) {
    case 'ecf':
      return renderEcfHeader();
    case 'plus':
      return renderPlusHeader();
    case 'about_company':
      return renderAboutCompanyHeader();
    default:
      return renderEcfHeader(); // フォールバック
  }
};

export default SimulatorHeader;
